import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const ManagementCommitee = () => {
    useEffect(() => {
        document.title = 'Management Committee -  The Air Force School Subroto Park';
    }, []);
    return (
        <>
            <Header />
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>
                    <li>  About Us</li>
                    <li>Management Committee</li>
                </ul>
            </div>
            <div className="innersec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1> Management Committee </h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <h6>The school is run by IAF Educational and Cultural Society through its Board of Governers (BOG).</h6>
                        </div>
                        <div className="managmentdiv">
                            <div className="managmentbox">
                                <img src="https://webapi.entab.info/api/image/TAFS/public/Images/Management.jpg" alt="TAFS" className=" img-fluid" />
                                <div className="managementdesc">
                                    <p>Air Marshal S Sivakumar, VSM  <span> Air Officer-in-Charge Administration</span>
                                        <span> Chairman, Board of Governors </span>
                                    </p>
                                </div>
                            </div>
                            <div className="managmentbox">
                                <img src="https://webapi.entab.info/api/image/TAFS/public/Images/Management8.jpg" alt="TAFS" className=" img-fluid" />
                                <div className="managementdesc">
                                    <p>Air Marshal PCP Anand, VSM  <span> Director General (Administration) </span>
                                        <span>  Senior Vice Chairman, Board of Governors</span></p>
                                </div>
                            </div>
                            <div className="managmentbox">
                                <img src="https://webapi.entab.info/api/image/TAFS/public/Images/Management4.jpg" alt="TAFS" className=" img-fluid" />
                                <div className="managementdesc">
                                    <p>	 Air Vice Marshal Harjit S Sidana, VSM <span> Assistant Chief of the Air Staff (Education) </span>
                                        <span>Executive Vice Chairman, Board of Governors</span>
                                    </p>
                                </div>
                            </div>
                            <div className="managmentbox">
                                <img src="https://webapi.entab.info/api/image/TAFS/public/Images/Management3.jpg" alt="TAFS" className=" img-fluid" />
                                <div className="managementdesc">
                                    <p>  Air Commodore Prasun Basu<span> Chairman Managing Committee, AF Schools </span>
                                    </p>
                                </div>
                            </div>
                            <div className="managmentbox">
                                <img src="https://webapi.entab.info/api/image/TAFS/public/Images/Management5.jpg" alt="TAFS" className=" img-fluid" />
                                <div className="managementdesc">
                                    <p> Wg Cdr Tinju Thomas<span> Executive Director, TAFS </span>
                                    </p>
                                </div>
                            </div>
                            <div className="managmentbox">
                                <img src="https://webapi.entab.info/api/image/TAFS/public/Images/Management6.jpg" alt="TAFS" className=" img-fluid" />
                                <div className="managementdesc">
                                    <p>Mrs Lomina Rajiv  <span> Principal </span>
                                    </p>
                                </div>
                            </div>
                            {  /*   <div className="managmentbox">
                            <img src="https://webapi.entab.info/api/image/TAFS/public/Images/Management7.jpg" alt="TAFS" className=" img-fluid"/> 
                            <div className="managementdesc">
                            <p>	Mrs Deepa Radhakrishnan <span> Headmistress </span>
                            </p>
                            </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ManagementCommitee